var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.491 1.66699H6.50768C3.47435 1.66699 1.66602 3.47533 1.66602 6.50866V13.4837C1.66602 16.5253 3.47435 18.3337 6.50768 18.3337H13.4827C16.516 18.3337 18.3243 16.5253 18.3243 13.492V6.50866C18.3327 3.47533 16.5243 1.66699 13.491 1.66699ZM8.25768 13.492C8.25768 14.0253 7.82435 14.4587 7.28268 14.4587C6.74935 14.4587 6.31602 14.0253 6.31602 13.492V10.7753C6.31602 10.242 6.74935 9.80866 7.28268 9.80866C7.82435 9.80866 8.25768 10.242 8.25768 10.7753V13.492ZM13.6827 13.492C13.6827 14.0253 13.2493 14.4587 12.716 14.4587C12.1743 14.4587 11.741 14.0253 11.741 13.492V6.50866C11.741 5.97533 12.1743 5.54199 12.716 5.54199C13.2493 5.54199 13.6827 5.97533 13.6827 6.50866V13.492Z",
    fill: "#007FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.7243905bc91ff1a43a6838acbd4a8f79.svg";
export { ForwardRef as ReactComponent };